// 我的 › 安全 › 存取紀錄（SPEC #device-permissions-audit）：別人分享給我的設備，我每次經分享看影像、回放、控制的紀錄（GET /v1/me/share-access-log）。
// 平台 H 起才有這條路由：舊後端回 404 → 顯示「這項功能還沒開放」，不當錯誤。
import { useTranslation } from 'react-i18next';
import { useQueries } from '@tanstack/react-query';
import { isKinioError } from '@kinio/web-sdk';
import { useScope } from '../../lib/scope';
import { shareApi } from '../../lib/planeApi';
import { scopeLabel } from '../people/SharesTab';
import { stamp } from '../../lib/timefmt';

export function MyAccessLogSection() {
  const { t } = useTranslation();
  const { planes, devices } = useScope();
  const qs = useQueries({ queries: planes.map((p) => ({ queryKey: ['me-share-access', p.api], queryFn: () => shareApi.myAccessLog(p.api), retry: false })) });
  const notYet = qs.length > 0 && qs.every((q) => q.isError && isKinioError(q.error) && (q.error.status === 404 || q.error.status === 405));
  const failed = !notYet && qs.some((q) => q.isError);
  const rows = qs.flatMap((q) => q.data?.entries ?? []).sort((a, b) => b.created_at.localeCompare(a.created_at));
  const nameOf = (ref?: string) => (ref ? devices.find((d) => d.device_ref === ref)?.display_name || ref : '—');
  return (
    <section className="card" data-testid="my-access-log">
      <h2 className="section-title">{t('mine.access_log')}</h2>
      <p className="muted small">{t('mine.access_log_hint')}</p>
      {notYet && <p className="muted small">{t('org.err_FEATURE_DISABLED')}</p>}
      {failed && <p className="error small">{t('scope.load_failed')}</p>}
      {!notYet && !failed && !qs.some((q) => q.isLoading) && rows.length === 0 && <p className="muted small">{t('mine.access_log_empty')}</p>}
      {rows.length > 0 && (
        <div className="table-wrap">
          <table className="grid">
            <thead>
              <tr>
                <th>{t('ext.when')}</th>
                <th>{t('ext.what')}</th>
                <th>{t('ext.device')}</th>
                <th>{t('mine.result')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((a) => (
                <tr key={a.access_id}>
                  <td className="small muted">{stamp(a.created_at)}</td>
                  <td className="small">{scopeLabel(t, a.action)}</td>
                  <td className="small">{nameOf(a.device_ref)}</td>
                  <td className="small">{t(`mine.result_${a.result}`, { defaultValue: a.result })}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
